import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { getDynamicsExcludeAccountFieldsThunk } from "../store/effects/dynamics/exclude";
import { getDynamicsMappingFieldsThunk } from "../store/effects/dynamicsApi";
import { getHsExcludeAccountFieldsThunk } from "../store/effects/hubspot/exclude";
import { getHsMappingFieldsThunk } from "../store/effects/hubspotApi";
import { getSfExcludeAccountFieldsThunk } from "../store/effects/salesforce/exclude";
import { getSfMappingFieldsThunk } from "../store/effects/salesforceApi";
import { selectIsCrmNotIntegrated } from "../store/selectors/crmSettingsSelectors";
import { selectDynamicsExcludeAccountFieldsRaw } from "../store/selectors/dynamicsSelectors";
import { selectHsExcludeAccountFieldsRaw } from "../store/selectors/hubspotSelectors";
import { selectSfExcludeAccountFieldsRaw } from "../store/selectors/salesforceSelectors";

export const useAllCrmMappingFieldsCall = (): void => {
    const dispatch = useDispatch();

    const sfExcludeAccountFields = useSelector(selectSfExcludeAccountFieldsRaw);
    const hsExcludeAccountFields = useSelector(selectHsExcludeAccountFieldsRaw);
    const dynamicsExcludeAccountFields = useSelector(selectDynamicsExcludeAccountFieldsRaw);

    const isHsNotIntegrated = useSelector((state) => selectIsCrmNotIntegrated(state, "hubspot"));
    const isSfNotIntegrated = useSelector((state) => selectIsCrmNotIntegrated(state, "salesforce"));
    const isDynamicsNotIntegrated = useSelector((state) => selectIsCrmNotIntegrated(state, "dynamics"));

    useEffect(() => {
        if (!isHsNotIntegrated) {
            void dispatch(getHsMappingFieldsThunk());

            if (!hsExcludeAccountFields.length) {
                void dispatch(getHsExcludeAccountFieldsThunk());
            }
        }
    }, [isHsNotIntegrated]);

    useEffect(() => {
        if (!isSfNotIntegrated) {
            void dispatch(getSfMappingFieldsThunk());

            if (!sfExcludeAccountFields.length) {
                void dispatch(getSfExcludeAccountFieldsThunk());
            }
        }
    }, [isSfNotIntegrated]);

    useEffect(() => {
        if (!isDynamicsNotIntegrated) {
            void dispatch(getDynamicsMappingFieldsThunk());

            if (!dynamicsExcludeAccountFields.length) {
                void dispatch(getDynamicsExcludeAccountFieldsThunk());
            }
        }
    }, [isDynamicsNotIntegrated]);
};
